import React, { Suspense, useState } from 'react';
import { Navigate } from 'react-router';

import { IRouteRule, UserRole } from './RouteManager';
import Loader from '../shared/loader';

type AccessCheckResult = 'AccessAllowed' | 'LoginRequired' | 'PermissionDenied';

interface IProtectedRoute {
	rule: IRouteRule;
}

export const checkAccess = (roles: any): any => {
	if (roles.includes(UserRole.Public)) {
		return 'AccessAllowed';
	}
};

export const AccessControl = (props: IProtectedRoute): JSX.Element => {
	const [authResult] = useState<AccessCheckResult>('AccessAllowed');

	switch (authResult) {
		case 'AccessAllowed':
			return <Suspense fallback={<Loader loading />}>{props.rule.element}</Suspense>;
		case 'PermissionDenied':
			return <></>;
		default:
			return <Navigate replace state={{ from: location }} to={'/'} />;
	}
};
